import React from "react";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import TestimoniesSlider from "../testimony-slider/testimonySlider";

import "./testimonies.scss";

const Testimonies = (props: ReferenciaContenido) => {
  let testimonies = Array();

  const handleMembers = () => {
    const refContent = props.referenciaPlantillaContenido.filter(cont => cont.imagenPrincipal)
    for (let i = 0; i < refContent.length; i++) {
      let testimony = {
        imagenPrincipal: {
          url:
            refContent[i].imagenPrincipal[0].file.url,
          alt: refContent[i].imagenPrincipal[0].title,
        },
        tituloBanner: refContent[i].tituloBanner,
        tituloDescripcion:
          refContent[i].tituloDescripcion,
        descripcion: refContent[i].descripcion
          ? refContent[i].descripcion
          : "",
      };
      if (typeof refContent !== "undefined") {
        testimonies.push(testimony);
      }
    }

    return testimonies;
  };

  handleMembers();

  return (
    <div className="m-testimonies-block">
      <div className="m-testimonies-block__head">
        <h2 className="m-testimonies-block__head-title">Testimonios</h2>
      </div>

      <div className="m-testimonies-block__slider">
        <TestimoniesSlider testimonies={testimonies} />
      </div>
    </div>
  );
};

export default Testimonies;
